import type { WindowLocation } from '@xing-com/crate-core-router';
import { useLocation } from '@xing-com/crate-core-router';
import type { JDP_SA_DEFAULT_QUERY } from '@xing-com/crate-jobs-constants';
import type { SearchAlertFilters } from '@xing-com/crate-jobs-helpers';

export type NavigationState = {
  [JDP_SA_DEFAULT_QUERY]?: SearchAlertFilters;
};

export const useNavigationState = (): NavigationState | undefined => {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const { state } = useLocation() as WindowLocation<NavigationState>;
  return state ?? undefined;
};
